import { Suspense } from 'react';
import { SpotlightSearch, UserProfile } from '@features';
import { Center, Flex, Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Logo } from './components';
import classes from './TopBar.module.css';

type TopBarPropsType = {
  toggleMobile: () => void;
  toggleDesktop: () => void;
};

/**
 * 💡 TopBar Component
 *
 * This component is a layout component that is used at the top of the page.
 * Layout components are used to define the structure of the page, such as
 * headers, footers, sidebars, etc. and belong in the `_layout` directory.
 */

export const TopBar: React.FC<TopBarPropsType> = ({
  toggleDesktop,
  toggleMobile,
}) => {
  const { t } = useTranslation();

  return (
    <Flex className={classes.topBarRoot}>
      <Group gap="lg" wrap="nowrap">
        <Logo toggleMenu={toggleMobile} hiddenFrom="sm" />
        <Logo toggleMenu={toggleDesktop} visibleFrom="sm" />
        <SpotlightSearch />
      </Group>
      <Center>
        <Text
          visibleFrom="sm"
          style={{
            fontFamily: 'Ivy Journal',
            fontSize: '1.620rem',
            color: 'var(--mantine-color-text-4)',
          }}
          truncate
        >
          {t('HEADER.TITLE')}
        </Text>
      </Center>
      <Center>
        <Suspense>
          <UserProfile />
        </Suspense>
      </Center>
    </Flex>
  );
};
